"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopiaBannerCTA = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var outline_1 = require("@heroicons/react/24/outline");
var classnames_1 = __importDefault(require("classnames"));
// import { trackAnalyticsEvent } from "../../_analytics";
function TopiaBannerCTA(props) {
    var fgColor = props.color === "royal-purple" ? "white" : "black";
    var textColor = "text-".concat(fgColor);
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("p-4 flex items-center cursor-pointer rounded-xl mt-4", "bg-".concat(props.color), props.className), onClick: function () {
            props.onClick && props.onClick();
            // if (props.analyticsEvent) {
            // trackAnalyticsEvent(props.analyticsEvent);
            // }
        }, children: [(0, jsx_runtime_1.jsx)("div", { children: props.illustration }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: (0, classnames_1.default)("text-md pl-4 font-bold m-0", textColor), children: (0, jsx_runtime_1.jsx)("span", { className: "", children: props.title }) }), (0, jsx_runtime_1.jsx)("p", { className: (0, classnames_1.default)("text-xs pl-4 m-0", textColor), children: props.copy })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex-1" }), (0, jsx_runtime_1.jsx)(outline_1.ArrowRightIcon, { className: "h-6 w-6", style: { color: fgColor } })] }));
}
exports.TopiaBannerCTA = TopiaBannerCTA;
// TODO
// This is a dummy component to trick tailwind into emitting color classes for everything
function Dummy() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "bg-royal-purple" }), (0, jsx_runtime_1.jsx)("div", { className: "bg-pale-yellow" }), (0, jsx_runtime_1.jsx)("div", { className: "bg-future-blue" }), (0, jsx_runtime_1.jsx)("div", { className: "bg-rgb-blue" })] }));
}
